<script setup lang="ts">
const buttonList = [
	{ name: 'About', url: ROUTE.ABOUT_US.NAME, external: false },
	{ name: 'Pricing', url: ROUTE.PRICING.NAME, external: false },
	{ name: 'Invitation', url: ROUTE.FEATURE_INVITATION.NAME, external: false },
	{ name: 'Hosting events', url: ROUTE.FEATURE_HOSTING_EVENTS.NAME, external: false },
	{ name: 'Blog', url: 'https://stories.peatix.com', external: true },
	{ name: 'Instagram', url: 'https://www.instagram.com/peatix', external: true },
	{ name: 'Help', url: ROUTE.HELP.NAME, external: false },
	{ name: 'Terms', url: ROUTE.TERMS.NAME, external: false },
];
</script>

<template>
  <div class="footer-link">
    <template
      v-for="(btn, index) in buttonList"
      :key="index"
    >
      <RouterLink
        v-if="!btn.external"
        :to="{ name: btn.url }"
      >
        <BaseButton
          class="link"
          variant="link"
          color="gray"
        >
          {{ btn.name }}
        </BaseButton>
      </RouterLink>
      <a
        v-else
        :href="btn.url"
        target="_blank"
        rel="noopener noreferrer"
      >
        <BaseButton
          class="link"
          variant="link"
          color="gray"
        >
          {{ btn.name }}
        </BaseButton>
      </a>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.footer-link {
    display: flex;
    gap: spacings-get(8);
    @include fonts-get(semibold, text-md);
    color: colors-get(gray, 600);

    .link {
      padding: 0;
    }
}

@include media-query-max(tablet) {
    .footer-link {
        flex-direction: column;
        align-items: center;
        gap: rem(18);
    }
}
</style>


